<template>
  <div class="pt-1">
    <!-- <v-row no-gutters>
          <v-col class="pl-4 font18 pt-2" style="display:flex;"><div :style="'color:' + $textcolor + ';font-weight: bold;'"
           class="pb-0 mr-3">ของรางวัล</div>  <v-icon class="iconify" data-icon="noto:wrapped-gift"></v-icon></v-col>
      <v-col
        class="text-end pr-2 font14 link pt-3"
        :style="'color:' + $textcolor + ';justify-content: flex-end;align-items: center;display: flex;'"
        v-if="newData"
        @click="$router.push('reward')"
        >ดูทั้งหมด <v-icon>mdi-chevron-right</v-icon>
      </v-col>
    </v-row> -->
    <!-- <div v-if="load"  style="height:200px;display:flex;align-items: center;">
      <v-row>
      <v-col cols="12" align="center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        </v-col>
      </v-row>
    </div> -->
    <!-- <div
      v-if="!load === false && !show"
      class="mx-auto"
      max-width="1600"
      :style="'margin-top:10px;background-color: white;'"
    >
      <v-slide-group active-class="success">
        <v-slide-item
          v-for="(item, i) in 5"
          :key="i"
          v-slot="{ active }"
        >
          <v-card
            :color="active ? undefined : 'lighten-1'"
            style="border-radius: 20px"
            class="ma-4 pa-2"
            width="200"
            elevation="8"
          >
            <v-skeleton-loader class="mx-auto" max-width="300" type="card">
            </v-skeleton-loader>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div> -->
    <!-- <button v-on:click="show = !show">
    Toggle
  </button> -->
<transition name="fade">
    <div
      v-if="load === false && show"
      max-width="1600"
      :style="'margin-top:10px;background-color: white;'"
    >
      <v-slide-group active-class="success">
        <v-slide-item v-for="(item, i) in items" :key="i" v-slot="{ active }">
          <v-card
            :color="active ? undefined : 'lighten-1'"
            style="border-radius: 20px"
            class="ma-2 pa-1 mt-4"
            width="200"
            elevation="2"
            max-height="250"
            min-height="250"
            @click="$router.push(`/reward/detail/${item.rewardId}`)"
          >
            <v-img
              :style="item.quotaCode <= 0 ? 'opacity: 0.5;' : null"
              :src="item.pictureUrl"
              height="180px"
              v-if="newData"
              @click="$router.push(`/reward/detail/${item.rewardId}`)"
            >
              <div v-if="item.levelNm !== 'All Level' && item.quotaCode > 0">
                <div
                  :style="
                    'width: 150px;' +
                    'height: 4px;' +
                    'transform: rotate(-30deg);' +
                    'position:absolute;' +
                    'top:13px;' +
                    'left:-50px;' +
                    'background-color:' +
                    item.color
                  "
                ></div>
                <div
                  :style="`width: 180px;height: 4px;background-color: ${item.color};transform: rotate(-30deg);position:absolute;top:24px;left:-20px;`"
                ></div>
                <div
                  :style="`position:absolute;left:-20px;top:10px;width:130px;background-color:${item.color};transform: rotate(-30deg);text-align:center;color:white;text-shadow: 1px 1px #000000; `"
                >
                  {{ item.levelName }}
                </div>
              </div>
            </v-img>
            <!-- <v-img :src="item.pictureUrl" height="176px" class="link" v-if="member === null"></v-img> -->
            <div
              v-if="item.quotaCode <= 0"
              style="
                position: absolute;
                left: 0px;
                top: 27px;
                text-align: center;
                color: #fff;
                background-color: red;
                width: 100px;
                border-style: solid;
                border-color: #fff;
                border-width: 2px;
                border-left-style: none;
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
              "
            >
              สินค้าหมด
            </div>
            <v-chip
              v-if="newData && item.supply !== 'admin'"
              class="ma-2 ml-n1 mt-n1"
              color="white"
              style="position: absolute; top: 140px; right: 5px"
            >
            <div style="display: flex;align-items: center;">
              <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <div v-if="item.resale && item.resale > 0">
                  <strong v-if="item.resale" class="text-center"
                      >{{item.resale}}
                  </strong>
                  <strong class="text-center" color="#181446" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 13px;"
                    >{{ formatNumber(item.point) }}
                  </strong>
                </div>
                <div v-else>
                  <strong class="text-center" color="#181446"
                    >{{ formatNumber(item.point) }}
                  </strong>
                </div>
            </div>
            </v-chip>
            <v-chip
              v-if="newData && item.supply === 'admin'"
              class="ma-2 ml-n1 mt-n1"
              color="white"
              style="position: absolute; top: 140px; right: 5px"
            >
            <div style="display: flex;align-items: center;">
              <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <!-- <div v-if="item.resale && item.resale > 0">
                  <strong class="text-center" color="#181446" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 13px;"
                    >{{ formatNumber(item.levelSettingsReward) }}
                  </strong>
                </div> -->
                <div>
                  <strong class="text-center" color="#181446"
                    >{{ findPointToRedeem(item.levelSettingsReward) }}
                  </strong>
                </div>
            </div>
            </v-chip>
            <v-card-text style="font-size: 16px" class="bold headline2">
              <v-col
                class="pl-2 pr-1 pt-1 pb-0"
                v-if="$i18n.locale === 'th' || item.nameEng === '' || item.nameEng === null"
                >{{ item.name.substring(0, 41) }}
              </v-col>
              <v-col
                class="pl-2 pr-1 pt-1 pb-0"
                v-else-if="$i18n.locale === 'en'"
                >{{ item.nameEng.substring(0, 41) }}
              </v-col>
              <!-- <v-col class="pl-2 pr-1 pt-2 pb-0">
                <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <strong class="text-center" style="font-size: 13px;"
                    >{{ formatNumber(item.point) }}
                  </strong>

                  <strong class="text-center" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 12px;"
                    >2,000
                  </strong>
              </v-col> -->
              <!-- <div>
                <div style="display: flex;align-items: center;">
                  <strong class="text-center" style="font-size: 16px;"
                    >{{ formatNumber(item.point) }}
                  </strong>
                  <strong class="text-center" style="text-decoration: line-through;color: grey;margin-left: 4px;"
                    >2,000
                  </strong>
                </div>
              </div> -->
            </v-card-text>
            <v-row class="fill-height" align="center" justify="center">
              <v-scale-transition>
                <v-icon
                  v-if="active"
                  color="white"
                  size="48"
                ></v-icon>
              </v-scale-transition>
            </v-row>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'MostPopular',
  data () {
    return {
      items: null,
      profile: null,
      session: this.$session.getAll(),
      DateNow: new Date(),
      load: true,
      show: false,
      shopId: null,
      isInClient: null
    }
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    this.isInClient = this.$liff.isInClient()
    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    findPointToRedeem (item) {
      try {
        const levelSettings = JSON.parse(item)
        if (Array.isArray(levelSettings)) {
          const matched = levelSettings.find(data =>
            data.levelId.toString() === this.newData.levelId && data.enabled === true
          )
          return matched ? matched.points : null
        }

        return null
      } catch (error) {
        console.error('findPointToRedeem error', error)
      }
    },
    async getReward () {
      const result = await axios.get(this.DNS_IP + '/reward/getColor?RECORD_STATUS=N', { headers: {lineUserId: this.profile.userId, lineId: this.profile.userId, shopId: this.shopId} })
      // const result = await this.callBeTaskAPI(
      //   'get',
      //   '/reward/getColor?RECORD_STATUS=N'
      // )
      // result.data.map(item => console.log('fffff', item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD')))
      if (Array.isArray(result.data)) {
        let a = result.data.filter(item => item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD'))
        result.data.map(item => item.expireTypeReward === 'Redeem' ? a.push(item) : null)
        this.items = a.sort((a, b) => { return a.point - b.point })
        this.items = this.items.filter(item => item.showReward !== 'False')
        this.items = this.items.filter(item => item.rewardId !== 338)
          .filter((item2) => {
            if (item2.supply === 'admin') {
              if (item2.levelSettingsReward) {
                const levelSettings = JSON.parse(item2.levelSettingsReward)

                if (Array.isArray(levelSettings)) {
                  return levelSettings.some(data =>
                    data.levelId.toString() === this.newData.levelId && data.enabled === true
                  )
                }
                console.log('this.items1000', this.items)
              } else {
                return item2
              }
            } else {
              return item2
            }
          })

        this.load = false
        this.show = true
      }
      this.$checkGetReward = true
    }
  }
}
</script>
<style scoped>
.skeleton {
  opacity: 0.7;
  animation: skeleton-loading 5s linear infinite alternate;
}

.skeleton-text {
  width: 100%;
  height: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.125rem;
}

.skeleton-text:last-child {
  margin-bottom: 0;
  width: 80%;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 70%);
  }

  100% {
    background-color: hsl(200, 20%, 95%);
  }
}
.v-slide-group__wrapper{
  padding-left: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MostPopular.vue